import { Typography, Container, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import Botao from '../Botao/Botao';
import Modal from '../Modal/Modal';
import { BotaoContainer, ModalContainerEditCommission } from './styles';
import CommissionSalesService, { IProposalWeBroPayInfo } from '../../services/CommissionSalesService';
import Snackbars from '../Snackbars';

interface EditCommissionStatusModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  currentStatus: 'BLOQUEADO' | 'LIBERADO';
  idVenda: string;
  weBroPaySalesInfo: IProposalWeBroPayInfo;
  setWeBroPaySalesInfo: (weBroPaySalesInfo: IProposalWeBroPayInfo) => void;
}

const EditCommissionStatusModal = (props: EditCommissionStatusModalProps): any => {
  const { isModalOpen, onClose, onOpen, currentStatus, idVenda, weBroPaySalesInfo, setWeBroPaySalesInfo } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarProps, setSnackbarProps] = React.useState<{
    message: string;
    type: 'success' | 'error' | 'info';
  }>({
    message: '',
    type: 'info',
  });

  React.useEffect(() => {
    if (isModalOpen && onOpen) {
      onOpen();
    }
  }, [isModalOpen, onOpen]);

  const handleSnackbarClose = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
      setSnackbarOpen(false);
  };

  const handleChangeCommissionStatus = async () => {
    setIsLoading(true);

    try {
      if (currentStatus === 'BLOQUEADO') {
        await CommissionSalesService.unlockCommissionSales(idVenda);
      } else {
        await CommissionSalesService.lockCommissionSales(idVenda);
      }

      onClose();

      setWeBroPaySalesInfo({
        ...weBroPaySalesInfo,
        sales: weBroPaySalesInfo.sales.map((sale) => ({
        ...sale,
        pagamentoLiberado: sale.idVenda === idVenda ? currentStatus === 'BLOQUEADO' : sale.pagamentoLiberado
        }))
      });

        setSnackbarProps({
          message: currentStatus === 'BLOQUEADO' ? 'Comissão liberada com sucesso!' : 'Comissão bloqueada com sucesso!',
          type: 'success',
        });
        setSnackbarOpen(true);
    } catch (error) {
      onClose();
        setSnackbarProps({
          message: 'Erro ao atualizar status da comissão',
          type: 'error',
        });
        setSnackbarOpen(true);
    } finally {
        setIsLoading(false);
      }
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        width={440}
        onClose={onClose}
      >
        <ModalContainerEditCommission>
          <Typography className="title">Editar status comissão</Typography>
          <Container className="text-container">
            <Typography variant="subtitle2" className={currentStatus === 'BLOQUEADO' ? 'status-bloqueado' : 'status-liberado'}>
              Status atual: <strong>{currentStatus}</strong>
            </Typography>

            <Typography variant="subtitle2" className="text-confirmacao">
              {currentStatus === 'BLOQUEADO'
                ? 'Você quer liberar a comissão?'
                : 'Você quer bloquear a comissão?'
              }
            </Typography>
            {currentStatus === "BLOQUEADO" && (
              <Alert severity="warning">
                Para liberar a comissão garanta que o contrato esteja assinado e o sinal pago.
              </Alert>
            )}
          </Container>
          <BotaoContainer>
            <Botao
              tipo={currentStatus === 'BLOQUEADO' ? 'salvar' : 'deletar'}
              tamanho="medio"
              className={currentStatus === 'BLOQUEADO' ? 'btn-liberar' : 'btn-bloquear'}
              onClick={handleChangeCommissionStatus}
              disabled={isLoading}
            >
              {isLoading && (
                <CircularProgress size={24} color="inherit" />
              )}
              {!isLoading && (
                currentStatus === 'BLOQUEADO' ? 'Liberar' : 'Bloquear'
              )}
            </Botao>
          </BotaoContainer>
        </ModalContainerEditCommission>
      </Modal>
      <Snackbars
        type={snackbarProps.type}
        handleClose={handleSnackbarClose}
        open={snackbarOpen}
      >
        {snackbarProps.message}
      </Snackbars>
    </>
  );
};

export default EditCommissionStatusModal;
